module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen2@2x-15a82a0503f7bee92e1fa48082910f11.png";